import { render, staticRenderFns } from "./AuctionListItem.vue?vue&type=template&id=2fac14e6"
import script from "./AuctionListItem.vue?vue&type=script&lang=js"
export * from "./AuctionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports